import PromptEditor from '../shared/PromptEditor';
import '../WorkflowEditor.css';

function MetadataSection({ config, dispatch }) {
  const update = (field, value) => {
    dispatch({ type: 'UPDATE_CONFIG', updates: { [field]: value } });
  };

  return (
    <div className="wfe-metadata">
      {/* General Info */}
      <div className="wfe-section-card">
        <div className="wfe-section-title">General Information</div>

        <div className="wfe-form-row">
          <div className="wfe-form-group">
            <label className="wfe-form-label">Workflow Name</label>
            <input
              className="wfe-input"
              type="text"
              value={config.name || ''}
              onChange={(e) => update('name', e.target.value)}
            />
          </div>
          <div className="wfe-form-group">
            <label className="wfe-form-label">
              Identifier <span className="wfe-form-hint">(read-only)</span>
            </label>
            <input className="wfe-input wfe-input-readonly" type="text" value={config.id} readOnly />
          </div>
        </div>

        <div className="wfe-form-row wfe-form-row-full">
          <div className="wfe-form-group">
            <label className="wfe-form-label">Description</label>
            <textarea
              className="wfe-textarea"
              rows={3}
              value={config.description || ''}
              onChange={(e) => update('description', e.target.value)}
            />
          </div>
        </div>

        <div className="wfe-form-group">
          <label className="wfe-form-label">Status</label>
          <div className="wfe-toggle-row">
            <button
              className={`wfe-toggle ${config.active !== false ? 'on' : ''}`}
              onClick={() => update('active', config.active === false)}
              type="button"
            />
            <span className="wfe-toggle-label">
              {config.active !== false ? 'Active' : 'Inactive'}
            </span>
          </div>
          <p className="wfe-toggle-desc">
            Active workflows are available for case creation. Deactivating hides it from the facility type selector but preserves existing cases.
          </p>
        </div>
      </div>

      {/* System Instruction */}
      <div className="wfe-section-card">
        <div className="wfe-section-title">System Instruction</div>

        <PromptEditor
          label="LLM Context Instruction"
          helpText="sent as system context when creating the document cache"
          value={config.system_instruction || ''}
          onChange={(val) => update('system_instruction', val)}
          rows={6}
          showStats={true}
        />
      </div>
    </div>
  );
}

export default MetadataSection;
